import React, { Component } from 'react'

export default class Footer extends Component {
  render () {
    return (
      <div className="footer" id="footer">

        <div className="footer_part">
          <p>
            © Copyright 2019 Onestop Mediebyrå AB
          </p>
        </div>
        <div className="footer_part">
          <p></p>
        </div>
        <div className="footer_part">
          <p>
          </p>
        </div>
        <div className="footer_part">
          <p>Version: {process.env.REACT_APP_VERSION}</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Footer.jsx